import React, { useState, useEffect, useRef, useContext } from "react";
import { UserInformationContext, C4FStatusContext, InfoModalContext, ReferenceDataContext } from "../main/App";
import { DropdownButton, ButtonGroup, Dropdown, Button, Row, Col, Alert, Table } from 'react-bootstrap';
import '../css/general.css';
import config from "../etc/config.json";
import C4FChat from '../common/C4FChat';
import CalendarModal from "../calendar/CalendarModal";
import moment from 'moment';
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import { getUnicodeOrImageFlag, getUnicodeFlag, getC4FCodeForCountryCode, getDateList, getRegularTeam, hasNationalTeam, getNationalTeam, isNationalTeamRace } from "../common/Helpers";
import { getJersey } from "./C4FLeaderJerseys";
import C4FSimpleTable from "../common/C4FSimpleTable";


function Inscription(props) {

  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const { showTeamInfo, showRiderInfo } = useContext(InfoModalContext);
  const { countries } = useContext(ReferenceDataContext);
  const mounted = useRef(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [team, setTeam] = useState(null);
  const [racerTeam, setRacerTeam] = useState(null);
  const [tab, setTab] = useState('nextRaces');
  const [upcomingRaceEditions, setUpcomingRaceEditions] = useState(null);
  const [sortFromPosition, setSortFromPosition] = useState(2);
  const [raceFilter, setRaceFilter] = useState('availableRaces');
  const [selectedRaceEdition, setSelectedRaceEdition] = useState(null);
  const [showCalendarRaceId, setShowCalendarRaceId] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const handleCloseCalendar = () => setShowCalendar(false);

  function getInscribeButton(rider, isInscribed) {
    if (isInscribed)
      return <Button size="sm" variant={'primary'} onClick={() => retireRacer(rider.id)}>Un-inscribe</Button>
    else
      return <Button size="sm" variant={'outline-primary'}
        disabled={racerTeam.racers.length >= selectedRaceEdition.race.ridersPerTeam}
        onClick={() => inscribeRacer(rider.id)}>Inscribe</Button>
  }

  function handleShowCalendar(raceId) {
    if (mounted.current) {
      setShowCalendarRaceId(raceId);
      setShowCalendar(true);
    }
  };

  function handleShowRaceEditionDetails(raceEditionId) {
    refreshSelectedRaceEdition(raceEditionId, team);
    // loadTeamInscription(raceEditionId)
    if (tab !== 'raceOverview') setTab('raceOverview');
  }
  function retireTeam(raceEditionId) {
    retire(raceEditionId, team.teamName, '', 'retireTeam');
    setTab('nextRaces');
  }
  function retireRacer(racerId) {
    retire(selectedRaceEdition.id, team.teamName, racerId, 'retireRacer');
  }
  function clearRacers() {
    retire(selectedRaceEdition.id, team.teamName, '', 'clearRacers');
  }

  function retire(raceEditionId, teamName, racerId, action) {
    handleBackendRequest('POST', '/raceEdition/' + raceEditionId + '/team/' + teamName + '/retire',
      {},
      {
        racerId: racerId,
        action: action
      },
      function (retireResponse) {
        if (action === 'retireTeam') {
          setRacerTeam(null);
          loadTeam(teamName, raceEditionId);
        }
        else
          setRacerTeam(retireResponse);
      },
      false);
  }

  function inscribeTeam(raceEditionId) {
    signup(raceEditionId, team.teamName, '', 'no', 'no', 1);
    setTab('manageInscription');
  }
  function inscribeRacer(racerId) {
    signup(selectedRaceEdition.id, team.teamName, racerId, 'no', 'no', 1);
  }
  function fillRacers(selectedOption) {
    signup(selectedRaceEdition.id, team.teamName, '', selectedOption, 'no', 1);
  }
  function sortRacers(selectedOption) {
    signup(selectedRaceEdition.id, team.teamName, '', 'no', selectedOption);
  }
  function signup(raceEditionId, teamName, racerId, fillRacers, sortRacers) {
    handleBackendRequest('POST', '/raceEdition/' + raceEditionId + '/team/' + teamName + '/signUp',
      {},
      {
        racerId: racerId,
        fillRacers: fillRacers,
        sortRacers: sortRacers,
        sortFromPosition: sortFromPosition
      },
      function (response) {
        setRacerTeam(response);
        if (!racerId) {
          loadTeam(teamName, raceEditionId);
        }
      });
  }
  function moveInscription(targetRaceEditionId) {
    handleBackendRequest('POST', '/raceEdition/' + selectedRaceEdition.id + '/team/' + team.teamName + '/moveInscription',
      {},
      {
        targetRaceEditionId: targetRaceEditionId
      },
      function () {
        loadTeam(team.teamName, targetRaceEditionId);        
      });
  }

  function getRaceDays(race) {
    return getDateList(race.startingDate, race.duration);
  }

  function loadTeamInscription(raceEditionId) {
    handleBackendRequest('GET', '/raceEdition/' + raceEditionId + '/team/' + team.teamName, null, null, setRacerTeam);
  }

  function loadTeam(teamName, relatedRaceEditionId = null) {
    handleBackendRequest('GET', '/team/' + teamName, null, { returnRiders: 'false' },
      function (team) {
        team.raceDays = [];
        if (team.currentRaceEdition)
          team.raceDays = getRaceDays(team.currentRaceEdition);
        if (team.nextRaceEditions)
          team.nextRaceEditions.forEach(re => team.raceDays = team.raceDays.concat(getRaceDays(re)))
        setTeam(team);
        if (!upcomingRaceEditions)
          loadUpcomingRaceEditions(team);
        else {
          setUpcomingRaceEditions(enrichUpcomingRaceEditions(upcomingRaceEditions, team));
          if (relatedRaceEditionId)
            refreshSelectedRaceEdition(relatedRaceEditionId, team);
        }
      }
    );
  }

  function isTeamEligibleForRace(team, raceEdition) {
    if (isNationalTeamRace(raceEdition.race.eventType))
      return team.type === 'NationalTeam';
    else
      return getRaceDays(raceEdition.race).filter(day => team.raceDays.includes(day)).length === 0 &&
        team.division >= raceEdition.minDivision && team.division <= raceEdition.maxDivision;
  }

  function refreshSelectedRaceEdition(raceEditionId, team) {
    handleBackendRequest('GET', '/raceEdition/' + raceEditionId,
      null, { context: 'inscription' },
      function (raceEdition) {
        let updatedRaceEditions = enrichUpcomingRaceEditions(upcomingRaceEditions
          .filter(re => re.id !== raceEdition.id)
          .concat([raceEdition]), team);
        setUpcomingRaceEditions(updatedRaceEditions);
        setSelectedRaceEdition(updatedRaceEditions.find(re => re.id === raceEdition.id));
        if (raceEdition.teams.some(t => t.team.teamName === team.teamName))
          loadTeamInscription(raceEdition.id);
        else
          setRacerTeam(null);
      });
  }

  function enrichUpcomingRaceEditions(raceEditions, team) {
    return raceEditions.map(re => ({
      ...re,
      raceDays: getRaceDays(re.race),
      eligible: isTeamEligibleForRace(team, re)
    }));
  }

  function loadUpcomingRaceEditions(team) {
    handleBackendRequest('GET', '/raceEdition/', null, { context: 'inscription' },
      function (loadedUpcomingRaces) {
        setUpcomingRaceEditions(enrichUpcomingRaceEditions(loadedUpcomingRaces, team));
      });
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function countTeams(raceEdition, ridersPerTeam) {
    let counter = 0;
    for (const obj of raceEdition) {
      if (obj.numberOfRacers === ridersPerTeam) counter++;
    }
    return counter;
  }

  function handleSetSelectedTeam(teamType) {
    let teamToSet = teamType === 'regularTeam' ? getRegularTeam(userInformation) : getNationalTeam(userInformation);
    if (!selectedTeam || teamToSet.teamName !== selectedTeam.teamName) {
      setSelectedTeam(teamToSet);
      loadTeam(teamToSet.teamName);      
    }
  }

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  useEffect(() => {
    if (!selectedTeam)
      handleSetSelectedTeam('regularTeam');
  }, []);

  if (upcomingRaceEditions && team)
    return <>
      <CalendarModal key={'calendar' + showCalendar}
        raceId={showCalendarRaceId}
        show={showCalendar}
        handleClose={handleCloseCalendar} />
      <Row className="my-2 justify-content-center">
        <ButtonGroup>
          <Button className={'py-1'} variant={(tab === 'nextRaces') ? 'primary' : 'outline-primary'} onClick={() => setTab('nextRaces')}>Upcoming Races</Button>
          {selectedRaceEdition !== null ?
            <Button className={'py-1'}
              variant={(tab === 'raceOverview') ? 'primary' : 'outline-primary'}
              onClick={() => handleShowRaceEditionDetails(selectedRaceEdition.id, team)}>Race Details {'\u21BB'}</Button>
            :
            <Button className={'py-1'}
              variant={(tab === 'raceOverview') ? 'primary' : 'outline-primary'} disabled>Race Details {'\u21BB'}</Button>
          }
          {racerTeam === null ?
            <Button className={'py-1'} variant={(tab === 'manageInscription') ? 'primary' : 'outline-primary'} disabled>My Inscription</Button>
            :
            <Button className={'py-1'} variant={(tab === 'manageInscription') ? 'primary' : 'outline-primary'} onClick={() => setTab('manageInscription')}>My Inscription</Button>
          }
        </ButtonGroup>
      </Row>
      {tab === 'nextRaces' && upcomingRaceEditions !== null && team !== null ?
        <>
          <Row className="my-2 justify-content-center">
            <ButtonGroup>
              <Button variant={(raceFilter === 'allRaces') ? 'primary py-1' : 'outline-primary py-1'} onClick={() => setRaceFilter('allRaces')}>All Races</Button>
              <Button variant={(raceFilter === 'availableRaces') ? 'primary py-1' : 'outline-primary py-1'} onClick={() => setRaceFilter('availableRaces')}>Available Races</Button>
            </ButtonGroup>
            {hasNationalTeam(userInformation) ?
              <ButtonGroup className="mx-2">
                <Button variant={(selectedTeam.type !== 'Regular' ? 'outline-' : '') + 'primary'}
                  onClick={() => handleSetSelectedTeam('regularTeam')}>Regular Team</Button>
                <Button variant={(selectedTeam.type !== 'NationalTeam' ? 'outline-' : '') + 'primary'}
                  onClick={() => handleSetSelectedTeam('nationalTeam')}>National Team</Button>
              </ButtonGroup>
              : null}
          </Row>
          <div className="row my-2 justify-content-center">
            <div className="col border-top border-bottom border-secondary" style={{ maxWidth: 1000, maxHeight: 150, fontSize: "0.8em", overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
              By inscribing in a race, you accept the fairplay rules:<br />

              <b><u>Prohibited team attacks:</u></b><br />

              <b>1. Normal Team Attack.</b> Attack (not following) with more than 2 riders of one team at the same km out of the same group.
              This rule is deactivated for the last 10 km of every race.<br />

              <b>2. Combined Team Attack.</b> Attack (not following) with more than 5 riders of one team during 20 km out of the same group, if these riders end up in the same group.
              This rule is deactivated in the second half of every race.<br />

              <b>3. Chained Attacks.</b> Escape (attacking or following) with more than 2 riders of one team at the same km out of the same group.
              This rule is deactivated: <br />
              - if {'≥'}11 riders from {'≥'}4 teams escape, or <br />
              - if the original group has {'≤'}14 riders, or <br />
              - if there are {'≤'}20 km left in the race, or <br />
              -  if the road incline is {'≥'}4%.<br />

              <b><u>Other fairplay rules:</u></b><br />
              - Sitting is only permitted in stage races. It is prohibited for one-day races.<br />
              - During stage races, it is mandatory to be online at least 20% of the stages = no sitter logged in during those stages.<br />
              - It is prohibited to share your password with another team. Any case of password sharing will be treated like a multi account case.<br />
              - Unrealistic arrangements are not allowed<br />
              - Every manager must do the best for his team . Separation of private and C4F is required.<br />

              IPs are controlled during races. <br />
            </div>
          </div>
          {team.balance <= -150000 ?
            <Row className="my-2 justify-content-center">
              <Col style={{ maxWidth: 1000, textAlign: "center" }}>
                <Alert variant="danger">Your balance is currently below -150.000. If you're still below when your next race starts, you won't be able to participate</Alert>
              </Col>
            </Row>
            : null}

          {userInformation.roles.includes("Banned") ?
            <Row className="my-2 justify-content-center">
              <Col style={{ maxWidth: 1000, textAlign: "center" }}>
                <Alert variant="danger">Your team is &#40;currently&#41; banned from participating in races due to fairplay violations (see Fairplay-Button).</Alert>
              </Col>
            </Row>
            : null}
          <Row className="justify-content-center">
            <Col className="justify-content-center" style={{ maxWidth: 1000, maxHeight: 500, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)', textAlign: "center" }}>
              <Table key={'nextRaces'} className="table table-sm table-striped align-middle text-center">
                <thead>
                  <tr className="table-secondary">
                    <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Start Date</th>
                    <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Start Time</th>
                    <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Race</th>
                    <th className="th-infotable" scope="col">Cat.</th>
                    <th className="th-infotable" scope="col">Days</th>
                    <th className="th-infotable" scope="col">Riders / Team</th>
                    <th className="th-infotable" scope="col">Teams</th>
                    <th className="th-infotable" scope="col">Div</th>
                    <th className="th-infotable" scope="col">Inscribe</th>
                    <th className="th-infotable" scope="col">Until</th>
                  </tr>
                </thead>
                <tbody>
                  {upcomingRaceEditions
                    .filter(raceEdition =>
                      raceFilter === 'allRaces' ||
                      raceEdition.eligible || team.nextRaceEditions && team.nextRaceEditions.map(re => re.id).includes(raceEdition.id))
                    .sort(function (a, b) { return a.startingDate.localeCompare(b.startingDate) || a.startingTime - b.startingTime })
                    .map((raceEdition) => (
                      <tr>
                        <td className="td-infotable" style={{ textAlign: "left" }}>{moment(raceEdition.startingDate).format('dd, D-MMM')}</td>
                        <td className="td-infotable" style={{ textAlign: "left" }}>{raceEdition.startingTime}:00 CET</td>
                        <td className="td-infotable" style={{ textAlign: "left", cursor: 'pointer' }} onClick={() => handleShowCalendar(raceEdition.race.id)}>
                          {getUnicodeOrImageFlag(countries, raceEdition.race.country, browserInfo)}&nbsp;{raceEdition.race.raceName.length > 25 ? (raceEdition.race.raceName.substr(0, 22) + '...') : raceEdition.race.raceName}</td>
                        <td className="td-infotable">{raceEdition.race.category}</td>
                        <td className="td-infotable">{raceEdition.race.duration}</td>
                        <td className="td-infotable">{raceEdition.race.ridersPerTeam}</td>
                        <td className="td-infotable">{raceEdition.numberOfParticipants}</td>
                        <td className="td-infotable">{raceEdition.minDivision} - {raceEdition.maxDivision}</td>
                        <td className="td-infotable">                          
                          {(() => {
                            if (team.nextRaceEditions.some(re => re.id === raceEdition.id))
                              return <Button variant="danger ml-1 mt-0 mb-1 py-1" size="sm" onClick={() => retireTeam(raceEdition.id)}>Un-inscribe</Button>
                            else if (raceEdition.eligible && userInformation.roles.includes("Banned"))
                              return <Button variant="outline-success ml-1 mt-0 mb-1 py-1" size="sm" disabled>Inscribe</Button>
                            else if (raceEdition.eligible)
                              return <Button variant="outline-success ml-1 mt-0 mb-1 py-1" size="sm" onClick={() => inscribeTeam(raceEdition.id)}>Inscribe</Button>
                            else
                              return <Button variant="outline-primary ml-1 mt-0 mb-1 py-1" size="sm" disabled>Inscribe</Button>
                          })()}
                          <Button variant="outline-primary ml-1 mt-0 mb-1 py-1" size="sm" onClick={() => handleShowRaceEditionDetails(raceEdition.id)}>Show</Button>
                        </td>
                        <td className="td-infotable">{raceEdition.startingTime - 1}:30 CET</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </>
        : null}
      {tab === 'raceOverview' && selectedRaceEdition !== null ?
        <div style={{ backgroundColor: 'rgba(222, 233, 244, 1)' }}>
          {team.balance <= -150000 ?
            <Row className="my-2 justify-content-center">
              <Col style={{ maxWidth: 1000, textAlign: "center" }}>
                <Alert variant="danger">Your balance is currently below -150.000. If you're still below when the race starts, you won't be able to participate</Alert>
              </Col>
            </Row>
            : null}
          <Row className=" d-flex">
            <Col className=" py-2 border border-secondary m-1 py-1 px-3" style={{ maxWidth: 746, maxHeight: 240, minWidth: 300, backgroundColor: 'rgba(245, 250, 255, 1)' }}>
              <b>Race Name:</b>  {selectedRaceEdition.race.raceName}<br />
              <b>Stages:</b>  {selectedRaceEdition.race.numberOfStages}<br />
              <b>Start Date:</b>  {moment(selectedRaceEdition.startingDate).format('dd, D-MMM-YYYY')}<br />
              <b>Start Time:</b>  {selectedRaceEdition.startingTime}:00 CET<br />
              <b>Deadline:</b>  {selectedRaceEdition.startingTime - 1}:30 CET<br />
            </Col>
            <Col className="col-12 border border-secondary m-1 py-1 pl-1 pr-0" style={{ maxWidth: 746, maxHeight: 240, backgroundColor: 'rgba(245, 250, 255, 1)' }}>
              <img onClick={() => handleShowCalendar(selectedRaceEdition.race.id)} style={{ maxHeight: "100%", maxWidth: "100%", cursor: 'pointer' }} alt="For one day races, profile will be shown here in the future." src={config.DIR_PROFILES + selectedRaceEdition.race.stages[0].id + ".png"}></img>
            </Col>
          </Row>
          <Row >
            <Col className=" m-1" style={{ backgroundColor: 'rgba(245,250,255,1)' }}>
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th className="th-infotable" scope="col">#</th>
                    <th className="th-infotable" style={{ textAlign: "left", paddingLeft: "3px" }}>Team</th>
                    <th className="th-infotable" scope="col">Div.</th>
                    <th className="th-infotable" scope="col">Races</th>
                    <th className="th-infotable" scope="col">Points</th>
                    <th className="th-infotable" scope="col">Inscribed Riders</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedRaceEdition.teams.slice()
                    .sort(function (a, b) { return a.team.division - b.team.division || b.team.pointsCurrent - a.team.pointsCurrent })
                    .map((racerTeam, index) => (
                      <tr>
                        <td className="td-infotable">{index + 1}</td>
                        <td className="td-infotable" style={{ textAlign: "left", paddingLeft: "2px" }}>
                          <Button className="btn-light py-0 m-0 my-1" onClick={() => showTeamInfo(racerTeam.team)}>
                            {racerTeam.team.teamName + (racerTeam.team.teamName !== racerTeam.team.ownerName ? ' (' + racerTeam.team.ownerAcronym + ')' : '')}
                          </Button>
                        </td>
                        <td className="td-infotable">{racerTeam.team.division}</td>
                        <td className="td-infotable">{racerTeam.team.raceStatistics.TotalRaces.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                        <td className="td-infotable">{racerTeam.team.pointsCurrent.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                        <td className="td-infotable">{racerTeam.numberOfRacers} / {selectedRaceEdition.race.ridersPerTeam}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <p><b>Fully signed up:</b> {countTeams(selectedRaceEdition.teams.slice(), selectedRaceEdition.race.ridersPerTeam)} Team&#40;s&#41;</p>
              {countTeams(selectedRaceEdition.teams.slice(), selectedRaceEdition.race.ridersPerTeam) < 5 ?
                <Alert variant={countTeams(selectedRaceEdition.teams.slice(), selectedRaceEdition.race.ridersPerTeam) < 2 ? 'danger' : 'warning'}>
                  Race will only start if at least two teams are signed up.</Alert>
              : null }
              {selectedRaceEdition.teams.some(rt => rt.numberOfRacers < selectedRaceEdition.race.ridersPerTeam && rt.team.teamName === getRegularTeam(userInformation)?.teamName) ?
                <Alert variant={'danger'}>Your inscription is incomplete</Alert>
              : null }
            </Col>
            <Col className=" border border-secondary m-1" style={{ minWidth: 400, backgroundColor: 'rgba(255,255,255,1)' }}>
              <C4FChat type="race"
                mode="readwrite"
                chat={selectedRaceEdition.id} user={userInformation.userName}
                refresh={0} height={288} />
            </Col>
          </Row>
        </div>
        : null}
      {tab === 'manageInscription' && racerTeam !== null && selectedRaceEdition !== null ?
        <>
          {team.balance <= -150000 ?
            <Row className="my-2 justify-content-center">
              <Col style={{ maxWidth: 1000, textAlign: "center" }}>
                <Alert variant="danger">Your balance is currently below -150.000. If you're still below when your next race starts, you won't be able to participate</Alert>
              </Col>
            </Row>
            : null}
          <Row class="d-flex">
            <Col className="col py-2 border border-secondary m-1 py-1 px-3" style={{ maxWidth: 746, maxHeight: 240, minWidth: 300, backgroundColor: 'rgba(245,250,255,1)' }}>
              <b>Race Name:</b>  {selectedRaceEdition.race.raceName}<br />
              <b>Stages:</b>  {selectedRaceEdition.race.numberOfStages}<br />
              <b>Start Date:</b>  {moment(selectedRaceEdition.startingDate).format('dd, D-MMM-YYYY')}<br />
              <b>Start Time:</b>  {selectedRaceEdition.startingTime}:00 CET<br />
              <b>Deadline:</b>  {selectedRaceEdition.startingTime - 1}:30 CET<br />
            </Col>
            <Col className="col py-2 border border-secondary m-1 py-1 px-3" style={{ maxWidth: 746, maxHeight: 240, minWidth: 300, backgroundColor: 'rgba(245,250,255,1)' }}>
              <b>My inscribed Riders:</b>  {racerTeam.racers.filter(racer => racer.nextRaceEdition !== 0).length} / {selectedRaceEdition.race.ridersPerTeam}<br />
              <b>My Salary:</b>  {numberWithCommas(racerTeam.racers.filter(racer => racer.nextRaceEdition !== 0).reduce((partialSum, a) => partialSum + a.rider.salary, 0))}<br />
              <b>Covered Salary:</b>  {numberWithCommas(375000 - ((9 - selectedRaceEdition.race.ridersPerTeam) * 40000))}<br />
            </Col>
          </Row>
          <Row className="m-1 justify-content-center">
            <Col className="col-6" >
              <ButtonGroup className="mx-1">
                <Button variant="secondary py-1" disabled>Fill remaining spots with</Button>
                <Button variant="outline-primary py-1" onClick={() => fillRacers('cheapest')}>cheapest</Button>
                <Button variant="outline-primary py-1" onClick={() => fillRacers('bestClimbers')}>best climbers</Button>
                <Button variant="outline-primary py-1" onClick={() => fillRacers('bestFlat')}>best flat</Button>
              </ButtonGroup>
            </Col>
            <Col className="col-6 justify-content-right" >
              <ButtonGroup className="mx-1">
                <Button className="py-1" variant="warning" onClick={() => clearRacers()}>Un-inscribe my riders</Button>
                <Button className="py-1" variant="danger" onClick={() => retireTeam(selectedRaceEdition.id)}>Un-inscribe my team</Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Row className="m-1 justify-content-center">
            <Col className="" style={{ maxWidth: 1000 }}>
              <ButtonGroup className="mx-2">
                <Button variant="secondary py-1" disabled>Sort inscribed riders</Button>
                <DropdownButton variant="outline-secondary py-1"
                  title={'from #' + sortFromPosition}
                  onSelect={(sortFromPosition, e) => setSortFromPosition(sortFromPosition)}>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((position) => {
                    if (position < selectedRaceEdition.race.ridersPerTeam) {
                      if (position === sortFromPosition)
                        return <Dropdown.Item active eventKey={position}>{position}</Dropdown.Item>
                      else
                        return <Dropdown.Item eventKey={position}>{position}</Dropdown.Item>
                    }
                    else return null;
                  })}
                </DropdownButton>
                <Button variant="outline-primary py-1" onClick={() => sortRacers('alphabetically')}>by name (A-Z)</Button>
                <Button variant="outline-primary py-1" onClick={() => sortRacers('climbing')}>by climbing</Button>
                <Button variant="outline-primary py-1" onClick={() => sortRacers('flat')}>by flat</Button>
                <DropdownButton variant="secondary py-1"
                  title={'move inscription to'}
                  onSelect={(targetRaceEditionId, e) => moveInscription(targetRaceEditionId)}>
                  {upcomingRaceEditions
                      .filter(re => re.race.id === selectedRaceEdition.race.id &&
                        re.id !== selectedRaceEdition.id && 
                        (re.maxDivision > 10 || team.division >= re.minDivision && team.division <= re.maxDivision) &&
                        re.moveInscriptionEnabled)
                      .sort(function (a, b) { return a.startingDate.localeCompare(b.startingDate) || a.startingTime - b.startingTime })
                      .map(re => 
                    <Dropdown.Item eventKey={re.id}>{re.startingTime}:00</Dropdown.Item>
                  )}
                </DropdownButton>
              </ButtonGroup>
            </Col>
          </Row>
          <Row className="m-1 justify-content-center">
            <Col className=" m-1" style={{ maxWidth: 1000, maxHeight: 600, overflow: "auto" }}>
              <C4FSimpleTable key={'ridersInscription'}
                initialSortingColumn={'riderName'}
                initialSortingAscending={true}
                hideFilterButtons={true}
                data={racerTeam.team.riders
                  .filter(rider => rider.age > 20)
                  .map(rider => {
                    let racer = racerTeam.racers.some(r => r.rider.id === rider.id) ? racerTeam.racers.find(r => r.rider.id === rider.id) : null;
                    return {
                      ...rider,
                      flag: getUnicodeFlag(rider.nationality),
                      c4fCode: getC4FCodeForCountryCode(countries, rider.nationality),
                      riderName: rider.firstNames + String.fromCharCode(160) + rider.lastNames,
                      jerseys: rider.jerseys.map(jersey => <img alt={jersey} title={jersey} src={getJersey('', jersey)} style={{ maxHeight: "18px" }} />),
                      climbing: rider.skills.Climbing,
                      flat: rider.skills.Flat,
                      downhill: rider.skills.Downhill,
                      timeTrial: rider.skills.TimeTrial,
                      sprint: rider.skills.Sprint,
                      cobblesCalculated: 0.7 * rider.skills.Flat + 0.3 * rider.skills.Cobbles,
                      regeneration: rider.skills.Regeneration,
                      energy: racerTeam.team.type === 'NationalTeam' ? 1000 : Math.round(rider.energy / 10),
                      form: racerTeam.team.type === 'NationalTeam' ? '?' : rider.formCurrent + ((rider.formTendency > 0) ? '+' : ((rider.formTendency === 0) ? '' : '-')),
                      number: racer ? racer.number : '-',
                      inscribeButton: getInscribeButton(rider, racer !== null)
                    }
                  })}
                rowMetadata={
                  [browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691' }
                    :
                    { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag' }]
                    .concat([
                      { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                      { columnName: 'age', columnDescription: 'Age' },
                      { columnName: 'salary', columnDescription: 'Salary', columnType: 'currency' },
                      { columnName: 'climbing', columnDescription: 'Climbing', columnHeader: <img src={SkillClimbing} title="Mountain" alt="Climbing" /> },
                      { columnName: 'flat', columnDescription: 'Flat', columnHeader: <img src={SkillFlat} title="Flat" alt="Flat" /> },
                      { columnName: 'downhill', columnDescription: 'Downhill', columnHeader: <img src={SkillDownhill} title="Downhill" alt="Downhill" /> },
                      { columnName: 'timeTrial', columnDescription: 'TimeTrial', columnHeader: <img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /> },
                      { columnName: 'sprint', columnDescription: 'Sprint', columnHeader: <img src={SkillSprint} title="Sprint" alt="Sprint" /> },
                      { columnName: 'cobblesCalculated', columnDescription: 'Cobbles', columnHeader: <img src={SkillCobbles} title="Cobbles" alt="Cobbles" /> },
                      { columnName: 'regeneration', columnDescription: 'Regeneration', columnHeader: <img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /> },
                      { columnName: 'energy', columnDescription: 'Energy', columnType: 'energy' },
                      { columnName: 'form', columnDescription: 'Form' },
                      { columnName: 'inscribeButton', columnDescription: 'Inscribe', columnType: 'object' },
                      { columnName: 'number', columnDescription: '#', columnType: 'string' }
                    ])
                }
              />

            </Col>
          </Row>
        </>
        : null}
    </>;
  else return null;
}
export default Inscription;